<template>
  <v-row>
    <v-col cols="12">
      <form @submit.prevent="save">
        <v-text-field
          label="Datum *"
          v-model="today"
          disabled
        ></v-text-field>
        <v-textarea
          :label="requireNotes ? 'Opombe *' : 'Opombe'"
          v-model="form.notes"
        ></v-textarea>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.notes.required)"
        >
          <FormErrorsLine v-if="!$v.form.notes.required" text="Polje je obvezno" />
        </FormErrors>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'

export default {
  components: {
    FormErrors,
    FormErrorsLine
  },
  props: {
    requireNotes: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      today: this.$moment().format('DD.MM.YYYY'),
      form: {
        notes: ''
      }
    }
  },
  validations () {
    return {
      form: {
        notes: {
          required: val => !this.requireNotes || val.length > 0
        }
      }
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        if (!this.form.notes) {
          this.form.notes = 'Brez opomb'
        }
        this.$emit('save', { ...this.form })
        this.form.notes = ''
        this.$v.form.$reset()
      }
    }
  }
}
</script>
